import Alpine from 'alpinejs'

// Define (mobile) menu open/close state
Alpine.store('menu', false)

// Define transition options for menu animations
Alpine.store('menuTransitions', {
  // The whole mobile menu when toggled
  mobileMenuContainer: {
    css: {
      // opacity: 0,
      transform: 'translateX(-100%)',
    },
    duration: 400,

    // Visuals controlled by the global 'menu' state
    bind: 'menu',
  },
})
